import { openDB } from 'idb';

const DB_NAME = 'fileStorage';
const STORE_NAME = 'files';

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME);
    }
  },
});

// Guardar archivo en IndexedDB
export const saveFile = async (key, file) => {
  const db = await dbPromise;
  await db.put(STORE_NAME, file, key);
};

// Obtener archivo de IndexedDB
export const getFile = async (key) => {
  const db = await dbPromise;
  return await db.get(STORE_NAME, key);
};

// Obtener todas las claves (IDs) de archivos almacenados
export const getAllKeys = async () => {
  const db = await dbPromise;
  return await db.getAllKeys(STORE_NAME);
};

// Eliminar archivo
export const deleteFile = async (key) => {
  const db = await dbPromise;
  await db.delete(STORE_NAME, key);
};

// Verificar si existe un archivo
export const exists = async (key) => {
  const db = await dbPromise;
  const value = await db.get(STORE_NAME, key);
  return value !== undefined;
};

// Extraer clave de archivo a partir de un thumb_url
export const extractFileKeyFromThumbUrl = (thumbUrl) => {
  if (!thumbUrl || typeof thumbUrl !== 'string') return '';
  try {
    const url = new URL(thumbUrl);
    // Si hay path, usar el último segmento; si no, usar el hostname
    const path = url.pathname || '';
    if (path && path !== '/' && path.length > 1) {
      const segments = path.split('/');
      const last = segments.pop() || segments.pop(); // maneja barra final
      return last || '';
    }
    return url.hostname || '';
  } catch (e) {
    // No es una URL absoluta, tomar el último segmento después de '/'
    const parts = thumbUrl.split('/');
    return parts[parts.length - 1] || '';
  }
};

// Dado un thumb_url, devolver la URL del recurso en IndexedDB si existe; si no, el original
export const resolveThumbUrlFromIndexedDb = async (thumbUrl) => {
  if (!thumbUrl) return '';
  const key = extractFileKeyFromThumbUrl(thumbUrl);
  //console.log('key: ', key);
  if (!key) return thumbUrl;
  const inDb = await exists(key);
  if (!inDb) return thumbUrl;
  const file = await getFile(key);
  //console.log('file: ', file);
  if (!file) return thumbUrl;
  try {
    return URL.createObjectURL(file);
  } catch (e) {
    return thumbUrl;
  }
};